<h2 class="sp-title">{{data.heading}}</h2>
<p *ngFor="let line of data.text">{{line}}</p>
<div mat-dialog-actions>
    <button mat-stroked-button class="cancel-button" (click)="dialogRef.close()">Cancel</button>
    <button mat-flat-button class="sp-background ok-button" color="primary" (click)="dialogRef.close(true)">Regenerate</button>

  </div>